import Swiper, { Lazy, Navigation, Scrollbar, Mousewheel } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-collection-carousel]',
};

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Lazy, Navigation, Scrollbar, Mousewheel],
      lazy: true,
      freeMode: true,
      slidesPerView: 1.3,
      spaceBetween: 20,
      mousewheel: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.slider-scrollbar',
        draggable: true,
        hide: false,
        snapOnRelease: false,
        dragSize: 80,
      },
      breakpoints: {
        768: {
          spaceBetween: 15,
          slidesPerView: 3,
          mousewheel: true,
          watchOverflow: true,
          scrollbar: {
            dragSize: 240,
          },
        },
        1280: {
          slidesPerView: 4,
        },
        1600: {
          slidesPerView: 5,
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.update();
    });
  }
}

customElements.define('collection-carousel', CollectionCarousel);
